import React, { Component, PureComponent } from 'react'
import { Icon, Popup } from 'semantic-ui-react'
import { Map, List, fromJS } from 'immutable'

function DataTableLimit({ meta, setLimit }) {
  let limit = meta.get('limit')

  let el = (
    <div className="datatable-controls-limit">
      <div className="ui form">
        <div className="ui input">
          <input
            type="text"
            defaultValue={limit}
            onBlur={e => setLimit(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                setLimit(e.target.value)
                return
              }
            }}
          />
        </div>
      </div>
    </div>
  )

  return (
    <Popup
      trigger={
        <div className="datatable-controls-box datatable-controls-box--hover">
          <b>Raja</b>
          <span>{meta.get('limit')}</span>
        </div>
      }
      style={{ margin: 0, padding: 0, borderRadius: 0 }}
      content={el}
      on="click"
      position="top left"
    />
  )
}

export default function DataTableControls({ meta = Map(), changePage, setLimit }) {
  let pages = []
  for (let i = 1; i <= meta.get('pages'); i++) {
    pages.push(i)
  }

  return (
    <div className="datatable-controls">
      <div className="datatable-controls-pager">
        <div className="datatable-controls-pager-buttons">
          <button
            className="datatable-controls-pager-item datatable-controls-pager-item--prev"
            onClick={e => e.preventDefault() & changePage('prev')}
            disabled={meta.get('currentPage') === 1}>
            <Icon name="chevron left" />
          </button>
          {pages.map((val, key) => {
            let page = key + 1
            let classes = ['datatable-controls-pager-item']
            let disabled = false
            if (page === meta.get('currentPage')) {
              disabled = true
              classes.push('datatable-controls-pager-item--active')
            }
            return (
              <button
                className={classes.join(' ')}
                onClick={e => e.preventDefault() & changePage(page)}
                disabled={disabled}
                key={page}>
                <span>{page}</span>
              </button>
            )
          })}
          <button
            className="datatable-controls-pager-item datatable-controls-pager-item--next"
            onClick={e => e.preventDefault() & changePage('next')}
            disabled={meta.get('currentPage') === meta.get('pages') || meta.get('pages') === 0}>
            <Icon name="chevron right" />
          </button>
        </div>
      </div>
      <div className="datatable-controls-info">
        <div className="datatable-controls-box">
          <b>Yhteensä</b>
          <span>{meta.get('count')}</span>
        </div>
        <div className="datatable-controls-box">
          <b>Sivu</b>
          <span>
            {meta.get('currentPage')} / {meta.get('pages')}
          </span>
        </div>
        <DataTableLimit setLimit={setLimit} meta={meta} />
      </div>
    </div>
  )
}
